class HttpService {
  constructor() {
    this.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.kygoods.com' : 'http://localhost:3000'
    this.router = null // Will be set by main.js
  }
  
  setRouter(router) {
    this.router = router
  }
  
  isGuestOrderRequest(url) {
    // 检查是否在访客结账流程中访问订单详情
    // 通过检查当前路径是否包含访客结账标识
    if (this.router && this.router.currentRoute) {
      const currentPath = this.router.currentRoute.path
      const query = this.router.currentRoute.query
      return currentPath.includes('/checkout/tappay-payment') && query.guest === 'true'
    }
    return false
  }

  async request(url, options = {}) {
    // 優先使用 user token，如果沒有則使用 customer token
    const userToken = localStorage.getItem('user_token')
    const customerToken = localStorage.getItem('token')
    const token = userToken || customerToken
    
    const config = {
      ...options,
      headers: {
        'Accept': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers
      }
    }

    // 如果不是文件上傳，則設置 Content-Type 為 application/json
    const isFileUpload = options.body instanceof FormData
    if (!isFileUpload && (!options.headers || !options.headers['Content-Type'])) {
      config.headers['Content-Type'] = 'application/json'
    }

    try {
      const fullURL = url.startsWith('/') ? `${this.baseURL}${url}` : `${this.baseURL}/${url}`
      console.log('Making request to:', fullURL, config)
      const response = await fetch(fullURL, config)
      
      // 检查是否应该跳过401自动处理（访客结账相关的端点）
      const guestCheckoutEndpoints = [
        '/api/v1/checkout/guest',
        '/api/v1/stores/current',
        '/api/v1/tappay/available-payment-methods',
        '/api/v1/tappay/create-order',
        '/api/v1/tappay/process-payment'
      ]
      // 访客订单详情API（动态匹配）
      const isGuestOrderApi = url.includes('/api/v1/orders/') && this.isGuestOrderRequest(url)
      const skipAutoRedirect = options.skipAutoRedirect || guestCheckoutEndpoints.some(endpoint => url.includes(endpoint)) || isGuestOrderApi
      
      if (response.status === 401 && !skipAutoRedirect) {
        // 401 錯誤自動登出並重定向
        console.log('Received 401 error, logging out user')
        
        // 清除所有認證相關的 localStorage
        localStorage.removeItem('token')
        localStorage.removeItem('customer')
        localStorage.removeItem('user_token')
        localStorage.removeItem('user')
        
        // 重定向到登入頁面 - 使用 router.push 以支持浏览器返回按钮
        if (this.router) {
          if (window.location.pathname.includes('/store/')) {
            this.router.push('/store/login')
          } else {
            this.router.push('/login')
          }
        } else {
          // Fallback to window.location if router is not available
          if (window.location.pathname.includes('/store/')) {
            window.location.href = '/store/login'
          } else {
            window.location.href = '/login'
          }
        }
        
        throw new Error('認證已過期，請重新登入')
      }
      
      return response
    } catch (error) {
      console.error('HTTP request error:', error)
      throw error
    }
  }

  async get(url, options = {}) {
    return this.request(url, { ...options, method: 'GET' })
  }

  async post(url, data, options = {}) {
    const requestOptions = {
      ...options,
      method: 'POST'
    }

    // 如果是文件上傳，直接使用 data 作為 body
    if (data instanceof FormData) {
      requestOptions.body = data
    } else {
      requestOptions.body = JSON.stringify(data)
    }

    return this.request(url, requestOptions)
  }

  async put(url, data, options = {}) {
    return this.request(url, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data)
    })
  }

  async patch(url, data, options = {}) {
    const requestOptions = {
      ...options,
      method: 'PATCH'
    }

    // 如果是文件上傳，直接使用 data 作為 body
    if (data instanceof FormData) {
      requestOptions.body = data
    } else {
      requestOptions.body = JSON.stringify(data)
    }

    return this.request(url, requestOptions)
  }

  async delete(url, options = {}) {
    return this.request(url, { ...options, method: 'DELETE' })
  }
}

export default new HttpService() 